import React from "react";
import { getSiteConfig } from "@/siteConfig";

const cols = [
    {
        title: "Product",
        links: [
            { l: "Features", h: "/#features" },
            { l: "Workflow", h: "/#workflow" },
            { l: "Showcase", h: "/#showcase" },
            { l: "Pricing", h: "/pricing" },
            { l: "Customer login", h: "/login" },
        ],
    },
    {
        title: "Resources",
        links: [
            { l: "FAQ", h: "/#faq" },
            { l: "Book a demo", h: "/demo" },
            { l: "Waitlist (macOS/Linux)", h: "/demo" },
            { l: "Contact support", h: "mailto:support@reachforge.io" },
        ],
    },
    {
        title: "Legal",
        links: [
            { l: "Privacy policy", h: "/privacy" },
            { l: "Terms of use", h: "/terms" },
            { l: "Refund policy", h: "/refund-policy" },
            { l: "Responsible use", h: "/responsible-use" },
            { l: "Anti-spam guidance", h: "/anti-spam" },
        ],
    },
];

export default function Footer() {
    const { version } = getSiteConfig();
    return (
        <footer
            data-testid="site-footer"
            className="bg-bg border-t-2 border-ink"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 pt-16 md:pt-20 pb-10">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <div className="font-display text-4xl md:text-5xl font-black tracking-tighter text-ink">
                            ReachForge
                        </div>
                        <p className="mt-4 text-ink-soft max-w-sm">
                            Desktop lead discovery and compliant outreach
                            tooling for serious B2B teams.
                        </p>
                        <div className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-ink-mute">
                            v{version} · Windows
                        </div>
                    </div>
                    <div className="lg:col-span-8 grid sm:grid-cols-3 gap-8">
                        {cols.map((c) => (
                            <div key={c.title}>
                                <div className="overline mb-4">{c.title}</div>
                                <ul className="space-y-3">
                                    {c.links.map((l) => (
                                        <li key={l.l}>
                                            <a
                                                href={l.h}
                                                data-testid={`footer-link-${l.l
                                                    .toLowerCase()
                                                    .replace(/[^a-z0-9]+/g, "-")}`}
                                                className="text-sm text-ink-soft hover:text-ink link-underline"
                                            >
                                                {l.l}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="mt-16 pt-6 border-t border-border flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink-mute">
                        © {new Date().getFullYear()} ReachForge ·{" "}
                        <a
                            href="/#website-request"
                            className="hover:text-ink link-underline"
                        >
                            Request a website
                        </a>
                    </p>
                    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink-mute">
                        Built for responsible B2B outreach
                    </p>
                </div>
            </div>
        </footer>
    );
}
